import { format } from 'date-fns'
import { Link } from 'gatsby'
import React from 'react'
import { cn, getPageUrl } from '../lib/helpers'
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"

import * as styles from './blog-post-preview.module.css'
import { responsiveTitle3 } from './typography.module.css'

function BlogPostPreview(props) {
  return (
    <Link
      className={props.isInList ? styles.inList : styles.inGrid}
      to={getPageUrl(props)}
    >
      <div className={styles.leadMediaThumb}>
        {
          props.main_image ? 
          <GatsbyImage image={props.main_image?.imageFile?.childImageSharp?.gatsbyImageData} alt={props.main_image.alternativeText ? props.main_image.alternativeText : 'a nice image'} />
          : <StaticImage src="../images/placeholder.png" alt=""/>
        }
      </div>
      <div className={styles.text}>
        <h3 className={cn(responsiveTitle3, styles.title)}>{props.title}</h3>
        {props.excerpt && (
          <div className={styles.excerpt}>
            {props.excerpt}
          </div>
        )}
        {props.publishedAt && (
          <div className={styles.date}>{format(props.publishedAt, 'MMMM Do, YYYY')}</div>
        )}
      </div>
    </Link>
  )
}

export default BlogPostPreview
